const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
export const API_BASE = isLocal ? "http://127.0.0.1:8000/api" : "/api";

export type OverviewResponse = {
  id?: string;
  status?: "processing" | "done" | "error";
  video?: string; 
  summary?: string;
  transcript?: string;
  script?: string;
  video_url?: string; 
  summary_video_url?: string;
  narration_duration_s?: number;
  final_duration_s?: number;
};

async function fetchJson(url: string, init?: RequestInit) {
  console.log("[Fetch] -> " + (init?.method || "GET") + " " + url);
  const res = await fetch(url, init);
  const text = await res.text();
  console.log("[Fetch] <- " + res.status + " from " + url + ": ", text.slice(0, 200));
  if (!res.ok) throw new Error(text || "HTTP " + res.status);
  return JSON.parse(text);
}

export async function requestVideoOverview(
  params: {
    input: "prompt" | "web" | "youtube" | "file";
    prompt?: string;
    url?: string;
    file?: File;
    duration_min?: number;
    voice_hint?: string;
    make_video?: boolean;
  },
  signal?: AbortSignal
): Promise<OverviewResponse> {
  const form = new FormData();
  form.set("input", params.input); 
  if (params.prompt) form.set("prompt", params.prompt);
  if (params.url) form.set("web_url", params.url); 
  if (params.file) form.set("file", params.file);
  form.set("duration_min", String(params.duration_min || 0.5));
  form.set("voice_hint", params.voice_hint || "nova");

  console.log("[VideoGen] Starting POST request to backend...");
  const startRes = await fetchJson(API_BASE + "/video/overview/", { method: "POST", body: form, signal });
  
  const jobId = startRes.id;
  if (!jobId) throw new Error("Failed to start generation job. No ID returned.");
  
  console.log("[VideoGen] Job created! ID: " + jobId + ". Starting polling loop...");

  return new Promise((resolve, reject) => {
    let pollCount = 0;
    const check = async () => {
      pollCount++;
      if (signal?.aborted) return reject(new Error("Aborted"));
      
      console.log("[VideoGen] Polling attempt #" + pollCount + " for Job " + jobId + " ...");
      try {
        const job = await fetchJson(API_BASE + "/jobs/" + jobId + "/?_t=" + Date.now(), { 
            cache: "no-store", 
            headers: { "Cache-Control": "no-cache, no-store, must-revalidate", "Pragma": "no-cache" } 
        });
        
        console.log("[VideoGen] Poll response status = " + job.status);
        
        if (job.status === "done") {
          console.log("[VideoGen] SUCCESS! Video is ready at: " + job.video);
          resolve({
            summary_video_url: job.video, 
            summary: job.summary,
            transcript: job.transcript,
            script: job.script,
            video_url: job.url, 
            final_duration_s: params.duration_min ? params.duration_min * 60 : 30
          });
        } else if (job.status === "error") {
          console.error("[VideoGen] Job failed:", job.summary);
          reject(new Error(job.summary || "Unknown error"));
        } else {
          setTimeout(check, 3000); 
        }
      } catch (e) {
        console.error("[VideoGen] Polling error:", e);
        setTimeout(check, 3000);
      }
    };
    setTimeout(check, 1000);
  });
}
